import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker'
import logout from '../../Global/logout' 

export default async function AddProvider(data) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    let listOfCountries = []
    if(data.countries.length > 0){
        data.countries.map(data => {
            return listOfCountries.push(data.value)
        })
    }
    

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/', {
            method: 'post',
            headers: { 'Authorization' : unHashedJwt},
            data: {
                "full_name": data.full_name.trim(),
                "email": data.email.trim(),
                "phone_number": data.phone_number.trim(),
                "business_countries": listOfCountries,  
                "company_country_uuid": data.countries[0].value,
                "company_address": data.company_address.trim(),
                "premisess_label": data.premisess_label,
                "terminal_label": data.terminal_label,
                "sequence_marker": "P",
                "company_place": data.company_place,
                "company_postal_code": data.company_postal_code,
                "company_legal_ID": data.company_legal_ID
            }     
        }).then(res => res)
        .catch(error => error.response.data.status === 401 ? logout() : error.response)
    );
}